import { render } from "./HeroAuthTitleHeader.vue?vue&type=template&id=162bd617&scoped=true"
const script = {}

import "./HeroAuthTitleHeader.vue?vue&type=style&index=0&id=162bd617&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162bd617"]])

export default __exports__